import { type ReactNode, useEffect } from 'react'
import './style.css'

export type ReactRenderTooltipProps = {
  text: ReactNode
  name: string
}
export const ReactRenderTooltip = (props: ReactRenderTooltipProps) => {
  const { text, name } = props

  useEffect(() => {
    console.log('ReactRenderTooltip', text, name)
  }, [text, name])

  return (
    <div className='react-render-tooltip'>
      <div>ID: {text}</div>
      <div>Name: {name}</div>
    </div>
  )
}
